import React from 'react';
import GetShopAuth, {GetShopAuthQueryData} from './graphql/GetShopAuth.graphql';
import {getServicesMarketplacePublicClient} from 'utilities/graphql';
import {notifyException} from 'utilities/analytics/bugsnag';

const client = getServicesMarketplacePublicClient();

export interface AuthState {
  currentShop: GetShopAuthQueryData.CurrentShop | null;
  currentShopUser: GetShopAuthQueryData.CurrentShopUser | null;
  loaded: boolean;
}

type wrappedComponentProps = AuthState & any;

function withAuth(
  WrappedComponent: React.ComponentType<wrappedComponentProps>
) {
  return class AuthWrapper extends React.Component<
    wrappedComponentProps,
    AuthState
  > {
    state: AuthState = {
      currentShop: null,
      currentShopUser: null,
      loaded: false,
    };

    componentDidMount() {
      this.fetchAuth();
    }

    async fetchAuth() {
      try {
        const {
          data: {currentShop, currentShopUser},
        } = await client.query<{
          currentShop: GetShopAuthQueryData.CurrentShop;
          currentShopUser: GetShopAuthQueryData.CurrentShopUser;
        }>({query: GetShopAuth});

        this.setState({currentShop, currentShopUser, loaded: true});
      } catch (error) {
        notifyException({error});

        this.setState({loaded: true});
      }
    }

    render() {
      return (
        <WrappedComponent
          loaded={this.state.loaded}
          currentShop={this.state.currentShop}
          currentShopUser={this.state.currentShopUser}
          {...this.props}
        />
      );
    }
  };
}

export default withAuth;
